<video #target class="video-js" vjs-layout-medium controls muted playsinline preload="none"></video>